import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  useModalState,
  Button,
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  Text,
  IconX,
  Center,
  ModalButton,
  ButtonProps,
  ModalTitle,
  csx,
  ModalDismiss,
} from '@vtex/admin-ui'
import { newOrder } from '@/checkout-instore-legacy/utils/SidebarUtils'
import classNames from 'classnames'

export type NewSaleModalDialogProps = ButtonProps

export function NewSaleModalDialog({
  className,
  ...props
}: NewSaleModalDialogProps) {
  const newSaleModalState = useModalState()

  return (
    <div>
      <Button
        data-testid="open-new-sale-modal-button"
        icon={<IconX title="close" color="black" />}
        className={classNames(
          csx({
            marginRight: '$space-1',
            alignItems: 'center',
          }),
          className
        )}
        onClick={() => newSaleModalState.toggle()}
        {...props}
      />
      <Modal aria-label="New sale modal" state={newSaleModalState} size="small">
        <ModalHeader>
          <ModalTitle>
            <FormattedMessage id="newSaleModalTitle" />
          </ModalTitle>
          <ModalDismiss />
        </ModalHeader>
        <ModalContent>
          <Text
            tone="secondary"
            variant="detail"
            className={csx({
              textAlign: 'justify',
            })}
          >
            <FormattedMessage id="newSaleModalContent" />
          </Text>
        </ModalContent>
        <ModalFooter
          className={csx({
            height: 100,
            placeContent: 'center',
          })}
        >
          <div
            className={csx({
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            })}
          >
            <ModalButton
              data-testid="modal-new-sale-button"
              variant="primary"
              className={csx({
                width: 310,
                height: 32,
              })}
              dismissModal
              onClick={newOrder}
            >
              <FormattedMessage id="newSaleModalButton" />
            </ModalButton>
            <Center>
              <ModalButton
                variant="tertiary"
                className={csx({
                  width: 310,
                  height: 32,
                  marginTop: '$space-2',
                })}
                dismissModal
              >
                <FormattedMessage id="newSaleModalCancelButton" />
              </ModalButton>
            </Center>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  )
}
